<template>
	<div>
		<spinner-component :loading="true"></spinner-component>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	created() {
		this.login()
	},
	methods: {
		...mapActions({
			setLocalStorage: 'setLocalStorage',
			setCompany: 'setCompany',
		}),
		login() {
			const { params, query } = this.$route

			axios
				.post(`/api/auth/magic-login/${params.user}`, {
					...query,
				})
				.then(({ data: { data } }) => {
					if (data.user && data.token) {
						this.setLocalStorage({
							user: JSON.stringify(data.user),
							token: data.token,
						})
					}

					if (data.company) {
						this.setCompany(data.company);
					}

					window.location = data.intended ?? '/app/dashboard'
				})
				.catch((response) => {
					console.log(response)
				})
		},
	},
}
</script>

<style lang="scss" scoped></style>
